import React, { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";

const PDFViewer: React.FC = () => {
  const location = useLocation();
  const history = useHistory();
  const [pdfURL, setPdfURL] = useState<string | null>(null);
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    // Detectar se é dispositivo móvel
    const userAgent = navigator.userAgent.toLowerCase();
    setIsMobile(/android|iphone|ipad|ipod|mobile/.test(userAgent));

    // Obter o ID da URL
    const params = new URLSearchParams(location.search);
    const id = params.get("id");

    if (!id) {
      history.push("/");
      return;
    }

    // Obter o URL do PDF do localStorage
    const url = localStorage.getItem(`pdfURL_${id}`);
    if (!url) {
      history.push("/");
      return;
    }

    setPdfURL(url);
  }, [location.search, history]);

  // Função para baixar o PDF
  const downloadPDF = () => {
    if (pdfURL) {
      const link = document.createElement("a");
      link.href = pdfURL;
      link.download = `documento.pdf`; // Nome do arquivo para download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  if (!pdfURL) {
    return <div>Carregando PDF...</div>;
  }

  return (
    <div style={{ width: "100%", height: "100vh", display: "flex", flexDirection: "column" }}>
      {/* Botão de download apenas em dispositivos móveis */}
      {isMobile && (
        <button
          onClick={downloadPDF}
          style={{
            padding: "10px",
            margin: "10px",
            backgroundColor: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Baixar PDF
        </button>
      )}

      {/* Exibir iframe em todos os dispositivos */}
      <iframe
        src={pdfURL}
        style={{ width: "100%", height: isMobile ? "calc(100% - 60px)" : "100%", border: "none" }}
        title="Relatório PDF"
      />
    </div>
  );
};

export default PDFViewer;